'use client';

import { ReactNode } from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Title,
    TitleLevels,
    TitleMarkup,
} from '@bytel/trilogy-react';

import { SSIBlock } from '@components/ssi-block';

import { LegalsSlugType, partials } from '@helpers/partials';

interface LegalsProps {
    id: string;
    url: LegalsSlugType;
    isItem?: boolean;
    className?: string;
}

interface LegalsContainerProps {
    id: string;
    children: ReactNode;
    isItem: boolean;
    className?: string;
}

function LegalsContainer({ id, children, isItem, className = '' }: Readonly<LegalsContainerProps>) {
    const content = (
        <AccordionItem data-cy='legals' id={id}>
            <AccordionHeader>
                <Title markup={TitleMarkup.H2} level={TitleLevels.SIX}>
                    Mentions légales
                </Title>
            </AccordionHeader>
            <AccordionBody>{children}</AccordionBody>
        </AccordionItem>
    );
    if (isItem) {
        return content;
    } else {
        return <Accordion className={className}>{content}</Accordion>;
    }
}

export function Legals({ id, url, isItem = false, className }: Readonly<LegalsProps>) {
    if (!url) {
        return null;
    }

    return (
        <SSIBlock url={partials.LEGALS(url)} container={LegalsContainer} containerProps={{ id, isItem, className }} />
    );
}
